<template>
	<div class="tips" :style="{ background, color, fontSize }">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: 'Tips',
	props: {
		background: {
			default: '#f3efe9',
		},
		color: {
			default: '#b6812a',
		},
		fontSize: {
			default: '12px',
		},
		padding: {
			default: '1px 4px',
		},
	},
}
</script>

<style scoped lang="less">
.tips {
	display: inline-block;
}
</style>
